import { Button, Currencies } from "@orbital/games-frontend-library"
import React, { useEffect, useState } from "react"
import { Wrapper, AnimatedText, ButtonWrapper } from "./FooterStyled"
import { ReactComponent as NewBetSVG } from "lib/assets/arrow-left.svg"
import { ReactComponent as ClearSVG } from "lib/assets/clear.svg"
// import { ReactComponent as AutoSVG } from 'lib/assets/auto.svg'

import { FOOTER_PROPS } from "./interface"
import stakeChecker from "functions/checkStake"
// import AUDIO from 'lib/audio/audios'
import useSound from "use-sound"
import cardDealOutSFX from "lib/audio/globals/cardDealOutSFX.mp3"
import { colors } from "lib/colors"
// import checkError from 'functions/handleErrorStates'

export default function FooterComponent({
  stake,
  gameInfo,
  isGameActive,
  SFXS,
  showResult,
  handleDeal,
  handlePlayerStake,
  handleBankerStake,
  handleTieStake,
  handleIsActive,
  handleNotification,
  sendBet,
  handleCardsClear,
  handleShowResult,
  handleDealOut,
  audio,
  isError,
  finalBalance,
}: FOOTER_PROPS): JSX.Element {
  const transition = "all 0.1s linear"

  const [isDisabled, setIsDisabled] = useState<boolean>(false)

  const [playcardDealOutSFX] = useSound(cardDealOutSFX, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })

  //need refactor
  useEffect(() => {
    if (!isGameActive && !showResult) {
      Number(stake) <= 0 ? setIsDisabled(true) : setIsDisabled(false)
    } else if (showResult) {
      setIsDisabled(false)
    }
  }, [isGameActive, stake, showResult])

  const { currency, precision, minBet, maxBet } = gameInfo

  const handleReset = () => {
    handlePlayerStake("0.00")
    handleBankerStake("0.00")
    handleTieStake("0.00")
  }
  const handleNewBet = () => {
    handleShowResult(false, 0)
    handleDealOut(true)
    setIsDisabled(true)
    setTimeout(() => {
      handleIsActive(false)
      handleCardsClear()
    }, 700)
    audio?.sound && playcardDealOutSFX()
  }

  const handlePlay = () => {
    if (
      stakeChecker(
        stake,
        maxBet,
        minBet,
        finalBalance,
        precision,
        currency,
        handleNotification,
      )
    ) {
      !isError && setIsDisabled(true)
      setTimeout(() => {
        sendBet()
        if (!isError) {
          handleIsActive(true)
          handleDeal(true)
        }
      }, 300)
    }
  }
  const handleRebet = () => {
    audio?.sound && playcardDealOutSFX()
    if (
      stakeChecker(
        stake,
        maxBet,
        minBet,
        finalBalance,
        precision,
        currency,
        handleNotification,
      )
    ) {
      handleShowResult(false, 0)
      handleDealOut(true)
      setIsDisabled(true)
      setTimeout(() => {
        handleCardsClear()
        setTimeout(() => {
          sendBet()
        }, 300)
      }, 700)
    } else {
      handleCardsClear()
      handleIsActive(false)
      handleShowResult(false, 0)
    }
  }

  const handleClick = () => {
    isGameActive ? handleRebet() : handlePlay()
  }
  const handleButtons = () => {
    isGameActive ? handleNewBet() : handleReset()
  }

  return (
    <Wrapper isGameActive={isGameActive} isDisabled={isDisabled}>
      <Button
        func={(b: boolean) => b && handleButtons()}
        SFX={isGameActive ? SFXS.newBetSFX : SFXS.clearSFX}
        customClass={isDisabled && "disable"}
        transition={transition}
        background={colors.secondary}
        textColor={colors.tertiaryDark}
      >
        <ClearSVG className='clear' />
        <NewBetSVG className='new' />
      </Button>
      {/* width={isGameActive ? '244px' : '178px'} */}
      <ButtonWrapper
        className='play'
        width='244px'
        isGameActive={isGameActive}
        isDisabled={isDisabled}
      >
        <Button
          width='100%'
          func={(b: boolean) => b && handleClick()}
          SFX={isGameActive ? SFXS.rebetSFX : SFXS.playSFX}
          customClass={isDisabled && "disable"}
          transition={transition}
          background={colors.secondary}
          textColor={colors.tertiaryDark}
        >
          <AnimatedText isGameActive={isGameActive} isDisabled={isDisabled}>
            PLAY
          </AnimatedText>
          <AnimatedText isGameActive={!isGameActive} isDisabled={isDisabled}>
            REBET
          </AnimatedText>
          <div className='stake'>
            <span>{Currencies[currency]}</span>
            <span>{(+stake).toFixed(precision)}</span>
          </div>
        </Button>
      </ButtonWrapper>
      {/* <ButtonWrapper className='auto' isGameActive={isGameActive}>
        <Button
          func={(b: boolean) => b && handleAbove('Auto')}
          SFX={SFXS.goForwardSFX}
          disableColor={colors.secondaryBackground}
          transition={transition}
        >
          <AutoSVG />
        </Button>
      </ButtonWrapper> */}
    </Wrapper>
  )
}
